module.exports = __webpack_public_path__ + "img/bg_letter_share.ab22a7c0.png";